<template>
  <div class="component-leadlist-step-2">
    <div v-if="!providerOptions.length" class="text-center my-5">
      <small class="text-danger">
        Nenhum provedor encontrado, cadastre um na aba de E-mail marketing.
      </small>
    </div>
    <form-group
      v-else
      select
      id="provider"
      label="Provedor"
      placeholder="Selecione uma opção..."
      :options="providerOptions"
      v-model="form.integration_id"
      @change="v => $emit('change-integration', v)"
    />

    <form-group
      v-if="provider && provider.name !== 'active_campaign'"
      slim
      id="name"
      v-model="form.name"
      label="Nome da segmentação"
      placeholder="Ex: (Boas-vindas)"
      :errors="errors.name"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false
    };
  },
  props: {
    product_id: {
      type: [Number, String],
      default: null
    },
    form: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapState("integration", ["providers", "mapProviderName"]),
    ...mapState("product", ["products"]),
    providerOptions() {
      return this.providers
        .filter(p =>
          ["leadlovers", "active_campaign", "rdstation"].includes(p.name)
        )
        .map(p => ({
          ...p,
          name: `${this.mapProviderName[p.name]} - ${p.description}`
        }));
    }
  }
};
</script>
